import { useEffect, useMemo, useState } from "react";
import { Industry } from "../../features/industries/types";
import agent from "../api/agent";
import { getISODate } from "../helpers/dateHelpers";

type DateRange = { start: Date; end: Date } | null | undefined;

const useExcursionIndustries = (dateRange?: DateRange) => {
  const [industries, setIndustries] = useState<Industry[]>([]);
  const dateFrom = dateRange?.start ? getISODate(dateRange.start) : undefined;
  const dateTo = dateRange?.end ? getISODate(dateRange.end) : undefined;

  useEffect(() => {
    agent.ExcursionIndustries.list(dateRange ? { dateFrom, dateTo } : undefined).then(setIndustries);
  }, [dateFrom, dateTo]); // eslint-disable-line react-hooks/exhaustive-deps

  return useMemo(
    () => ({
      industries,
      industryOptions: industries.map(({ id, name }) => ({ key: id, value: id, text: name })),
    }),
    [industries]
  );
};

export default useExcursionIndustries;
